/**
 *  Component Helpers
 */
 export function guid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Theme Helpers
 */
export const _COLORS_ = Object.freeze({
  0: 'primary',
  1: 'secondary',
  2: 'tertiary',
  4: 'quarternary',
  5: 'quinary',
  6: 'senary',
  7: 'gray-lite',
  8: 'gray-dark',
});

/**
 * Window Helpers
 */

// Keyboard Enum
export const _KEYBOARD_ = Object.freeze({
  'enter': 13,
  'arrow-u': 38,
  'arrow-r': 39,
  'arrow-d': 40,
  'arrow-l': 37,
  'esc': 27,
  'tab': 9,
  'space': 32
});

/**
 * Breakpoints are situatued such that
 * comparison would be "and down" --
 * 
 * if (window.innerWidth < _BREAKPOINTS_.sm) { ... }
 */
export const _BREAKPOINTS_ = Object.freeze({
  'xs': 576,
  'sm': 767,
  'md': 991,
  'lg': 1199,
  'xl': 1399,
  'giant': 1799
});

export const isOnScreen = function (el) {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  // Only completely visible elements return true
  return elemTop < window.innerHeight - 100 && elemBottom >= 0;
}

export const getQueryStringValue = (key) => {  
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
}  

export const scrollToTop = function() {
  window.scrollTo({
    behavior: 'smooth',
    top: 0,
  });
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function isScrolledIntoView(el, ratioVisible: number = 1): boolean {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;
  const offsetHeight = elemTop + (el.offsetHeight * ratioVisible);

  // Only completely visible elements return true:
  const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  const isPartiallyVisible = offsetHeight >= 0 && offsetHeight < window.innerHeight;
  
  return isVisible || isPartiallyVisible;
};
